<template>
    <div>
        <div v-if="value" class="assess-form pt-3 pb-3">
            <vue-element-loading :active="show" spinner="ring" color="#006db3" size="128" text="กรุณารอสักครู่..." is-full-screen/>

            <div class="card">
                <div class="card-body">
                    <h3 class="text-center m-0"><b>{{ formTitle }}</b></h3>
                    <small>{{ formDescription }}</small>

                    <form :class="'mt-3'+(validated ? ' was-validated':'')">
                        <div class="row">
                            <div class="col-sm-12 input-group-lg">
                                <label class="m-0"><b>ชื่อ-สกุล<span class="text-red">*</span></b></label>
                                <input type="text" :class="'form-control '+(validated ? 'is-invalid':'')" id="name" v-model="name" v-on:keyup.enter="nextPlease" placeholder="ชื่อ-สกุล" autocomplete="off" required>
                                <div v-if="name==''" class="text-left invalid-feedback">กรุณากรอกชื่อ-สกุล</div>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-sm-12 input-group-lg">
                                <label class="m-0"><b>เบอร์โทรศัพท์<span class="text-red">*</span></b></label>
                                <input type="tel" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');" :class="'form-control '+(validated ? 'is-invalid':'')" id="phone" v-model="phone" maxlength="10" placeholder="เบอร์โทรศัพท์" autocomplete="off" required />
                                <div v-if="phone==''" class="text-left invalid-feedback">กรุณากรอกเบอร์โทรศัพท์</div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div v-if="working" :class="validated ? ' was-validated':''">
                <div v-for="(itQ, idQ) in listQuestion" :key="idQ" class="card mt-2">
                    <div class="card-body p-3 pl-4 pr-4">
                        <div class="row pb-3">
                            <div class="col-12">
                                <label class="m-0"><b>{{ itQ.name }} <span v-if="itQ.request" class="text-danger">*</span></b></label>
                            </div>
                            <div class="col-12">
                                <small>{{ itQ.description }}</small>
                            </div>
                        </div>

                        <div class="row">
                            <div v-if="itQ.type.id=='radio'" class="col-12">
                                <div v-for="(itC, idC) in itQ.listChoice" :key="idC" class="form-check pb-2">
                                    <input class="form-check-input" :type="itQ.type.id" :name="itQ.type.id" :id="itQ.type.id+idC" :value="[itC.id]" v-model="itQ.choiceId" :required="itQ.request ? true:false">
                                    <label class="form-check-label pl-2" :for="itQ.type.id+idC"> {{ itC.name }}</label>
                                    <div v-if="(itQ.listChoice.length==(idC+1))" class="invalid-feedback m-0">กรุณาเลือกคำตอบ</div>
                                </div>
                            </div>
                            <div v-if="itQ.type.id=='checkbox'" class="col-12">
                                <div v-for="(itC, idC) in itQ.listChoice" :key="idC" class="form-check pb-2">
                                    <input class="form-check-input" :type="itQ.type.id" :name="itQ.type.id" :id="itQ.type.id+idC" :value="itC.id" v-model="itQ.choiceId" :required="itQ.request ? true:false">
                                    <label class="form-check-label pl-2" :for="itQ.type.id+idC"> {{ itC.name }}</label>
                                    <div v-if="(itQ.listChoice.length==(idC+1))" class="invalid-feedback m-0">กรุณาเลือกคำตอบ</div>
                                </div>
                            </div>
                            <div v-if="itQ.type.id=='option'" class="col-12">
                                <select class="form-control" v-model="itQ.choiceId" :required="itQ.request ? true:false">
                                    <option :value="[]" disabled>เลือก...</option>
                                    <option v-for="(itC, idC) in itQ.listChoice" :key="idC" :value="[itC.id]">{{ itC.name }}</option>
                                </select>
                                <div class="invalid-feedback m-0">กรุณาเลือกคำตอบ</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mt-2">
                <div class="card-body p-3">
                    <div class="row">
                        <div class="col-12">
                            <button type="button" class="btn btn-purple btn-block float-right" @click="validateSendResult">ส่งข้อมูล</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="assess-form pt-3 pb-3">
            <div class="card">
                <div class="card-body">
                    <h3 class="text-secondary">
                        <i class="fa fa-exclamation-circle" aria-hidden="true"></i> กรุณาสแกน QRcode อีกครั้ง
                    </h3>
                </div>
            </div>
        </div>

        <p v-if="value" class="text-note text-secondary">
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i> ข้อมูลของท่านจะถูกเก็บเป็นความลับ
        </p>
        
    </div>
</template>

<script>
import Vue from 'vue';
import Api from './../api';
export default {
    data(){
        return {
            show: false,
            validated: false,
            formTitle: '',
            formDescription: '',
            name: '',
            phone: '',
            value: null,
            userId: null,
            formId: null,
            listQuestion: [],
            working: false,
            answer: null
        }
    },

    created(){
        this.value = this.$route.query.V;
        this.formId = this.$route.query.F;
        if(this.value==undefined){
            this.$swal('ไม่พบข้อมูล!', 'กรุณาสแกน QRcode อีกครั้ง', "warning");
        }

        this.getFormById(this.formId);
    },

    watch: {

    },

    methods:{
        getFormById(id){
            this.show = true;
            Api.getFormById(id).then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.formTitle = data.result.name;
                    this.formDescription = data.result.description;
                    this.working = data.result.working;
                    this.listQuestion = data.result.question.map((it,id) => {
                        Vue.set(it, 'listChoice', it.choice);
                        Vue.set(it, 'type', it.choice_type);
                        Vue.set(it, 'choiceId', []);
                        return it;
                    });
                }else{
                    this.$router.push({name: 'errors'});
                }
            }).catch(err => {
                this.show = false;
                // this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
                this.$router.push({name: 'errors'});
            })
        },

        nextPlease(event) {
            document.getElementById('phone').focus();
        },

        validateSendResult(){
            this.validated = true
            if(this.working){
                var validateAnswer = this.listQuestion.find(it => {
                    if(it.request && it.choiceId.length<1){
                        return it
                    }
                });
            }

            if(this.name=='' || ((''+this.phone).length)!=10){
                this.$swal('ตรวจสอบข้อมูล!', 'ชื่อ-นามสกุลและเบอร์โทรศัพท์', "warning");
            }else if(this.value==undefined || this.formId==undefined){
                this.$swal('ใบเสร็จไม่มีข้อมูล!', 'กรุณาสแกน QRcode อีกครั้ง', "warning");
            }else if(validateAnswer!=undefined){
                this.$swal('ตรวจสอบคำตอบ!', '', "warning");
            }else{
                this.validated = false
                this.answer = this.listQuestion.map(it => {
                    return { 
                        questionId: it.id, 
                        choiceId: it.choiceId 
                    };
                });

                this.saveCustomer();
            }
        },

        saveCustomer(){
            this.show = true;
            var body = {
                name: this.name,
                phone: this.phone,
                value: this.value,
                formId: this.formId,
                answer: this.answer
            }
            Api.saveCustomer(body).then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    // check qrcode type bill 
                    var searchValue = this.value.search("|");
                    if(searchValue>0){
                        var arrValue = this.value.split("|"); // [0]: company, [1]:book, [2]:no, [3]:purchase,
                        var amount = Number(arrValue[3]); 
                        fbq('track', 'Purchase', {currency: "THB", value: amount});
                    }

                    this.$router.push({name: 'thanks', params: { result: true }});
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$router.push({name: 'errors'});
            })
        },
    }
}
</script>

<style scoped>
    .text-note {
        /* position: absolute; */
        bottom: 0px;
    }
</style>